/**
 * Pure domain logic for Cable connections filtering, source determination and formatting.
 */

export interface CableItemLike {
  cable_id: string;
  source_device?: string;
  target_device?: string;
  cable_type?: string;
  status?: string;
  netbox_id?: number | null;
  [key: string]: any;
}

export type CableSourceFilter = 'all' | 'netbox' | 'manual';

export function isNetBoxCable(cable: { netbox_id?: number | null }): boolean {
  return cable.netbox_id !== undefined && cable.netbox_id !== null && cable.netbox_id > 0;
}

export function formatCableSourceLabel(netbox_id?: number | null): string {
  if (netbox_id !== undefined && netbox_id !== null && netbox_id > 0) {
    return `NetBox #${netbox_id}`;
  }
  return 'Вручную';
}

export interface CableFilterOptions {
  search?: string;
  typeFilter?: string;
  statusFilter?: string;
  sourceFilter?: CableSourceFilter;
}

export function filterCables<T extends CableItemLike>(
  cables: T[],
  options: CableFilterOptions
): T[] {
  const {
    search = '',
    typeFilter = 'all',
    statusFilter = 'all',
    sourceFilter = 'all',
  } = options;

  const term = search.toLowerCase().trim();

  return cables.filter((cable) => {
    // Search
    if (term) {
      const src = (cable.source_device || '').toLowerCase();
      const tgt = (cable.target_device || '').toLowerCase();
      const cid = (cable.cable_id || '').toLowerCase();
      const nbid = cable.netbox_id ? String(cable.netbox_id) : '';
      const sp = (cable.source_port || '').toLowerCase();
      const tp = (cable.target_port || '').toLowerCase();
      const tag = (cable.tia_606_tag || '').toLowerCase();
      const matchesSearch =
        src.includes(term) ||
        tgt.includes(term) ||
        cid.includes(term) ||
        nbid.includes(term) ||
        sp.includes(term) ||
        tp.includes(term) ||
        tag.includes(term);
      if (!matchesSearch) return false;
    }

    // Type
    if (typeFilter && typeFilter !== 'all') {
      if ((cable.cable_type || '').toLowerCase() !== typeFilter.toLowerCase()) {
        return false;
      }
    }

    // Status
    if (statusFilter && statusFilter !== 'all') {
      if ((cable.status || '').toLowerCase() !== statusFilter.toLowerCase()) {
        return false;
      }
    }

    // Source (NetBox / Manual)
    if (sourceFilter === 'netbox') {
      if (!isNetBoxCable(cable)) return false;
    } else if (sourceFilter === 'manual') {
      if (isNetBoxCable(cable)) return false;
    }

    return true;
  });
}
